import { UseFormReturn } from "react-hook-form";
import EhsRoleDetailsCard from "./cards/EhsRoleDetailsCard";
import PermissionsCard from "./cards/PermissionsCard/PermissionsCard";
import {
  AvailableQualifier,
  EhsPermission,
  EhsRoleFormFields,
  PermissionRowData,
} from "./EhsRoleTypes";
import { Dispatch, useState } from "react";
import { QualifiersSidebar } from "./cards/PermissionsCard/QualifiersSidebar";
import { PermissionsAction } from "./PermissionsReducer";

interface EhsRoleFormProps {
  formMethods: UseFormReturn<EhsRoleFormFields, unknown>;
  onSubmit: () => void;
  isLoading: boolean;
  selected: Array<EhsPermission>;
  dispatch: Dispatch<PermissionsAction>;
}

const EhsRoleForm = ({
  formMethods,
  onSubmit,
  isLoading,
  selected,
  dispatch,
}: EhsRoleFormProps): React.ReactElement => {
  const { handleSubmit } = formMethods;

  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [openPermission, setOpenPermission] = useState(null);

  const onRowClick = async (rowData: PermissionRowData) => {
    setOpenPermission(rowData.data);
    dispatch({ type: "open", payload: rowData.data });
    setSidebarVisible(true);
  };

  const onHideSidebar = (
    values: any,
    availableQualifiers: AvailableQualifier[]
  ) => {
    dispatch({
      type: "close",
      payload: {
        qualifiers: values[values.id],
        permissionId: values.id,
        availableQualifiers,
      },
    });
    setSidebarVisible(false);
    setOpenPermission(null);
  };

  return (
    <form id="ehs-role-form" onSubmit={handleSubmit(onSubmit)}>
      <EhsRoleDetailsCard formMethods={formMethods} isLoading={isLoading} />
      <PermissionsCard
        dispatch={dispatch}
        selected={selected}
        onRowClick={onRowClick}
        isLoading={isLoading}
      />
      <QualifiersSidebar
        visible={sidebarVisible}
        onHide={onHideSidebar}
        selected={selected}
        currentPermission={openPermission}
      />
    </form>
  );
};

export default EhsRoleForm;
